import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * "{n} duplicates" badge for a primary report (design §9.4) — rendered only
 * when `debouncedCounter > 1` (create → 1; each accepted duplicate +1).
 * `n = debouncedCounter − 1`; the tooltip gives the full accounting.
 */
export function DuplicateCountBadge({ debouncedCounter }: { debouncedCounter: number }) {
  const duplicates = debouncedCounter - 1;
  if (duplicates < 1) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant="outline" className="cursor-help">
          {duplicates} duplicate{duplicates === 1 ? '' : 's'}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        {debouncedCounter} reports match this issue — 1 original + {duplicates} duplicate
        {duplicates === 1 ? '' : 's'}.
      </TooltipContent>
    </Tooltip>
  );
}
